(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifHours', swifHours)
    .directive('swifDate', swifDate)
    .directive('swifDatetime', swifDatetime);


    function swifHours(swifMomentUtility) {
        var d = {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {raw:'=?'}
        };
        d.template = '<span>{{duration}}</span>';
        d.link = function (scope, element, attr, ngModel) {
            ngModel.$render = function () {
                scope.duration = swifMomentUtility.formatHours(
                    ngModel.$viewValue,
                    scope.raw
                );
            };
        };
        return d;
    }

    
    function swifDate(swifMomentUtility) {
        var d = {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {
                format: '@'
            }
        };
        d.template = '<span uib-tooltip="{{timeago}}">{{date}}</span>';
        d.link = function (scope, element, attr, ngModel) {
            ngModel.$render = function () {
                scope.date = swifMomentUtility.formatDate(
                    ngModel.$viewValue, scope.format
                );
                scope.timeago = swifMomentUtility.timeago(
                    ngModel.$viewValue
                );
            };
        };
        return d;
    }

    
    function swifDatetime(swifMomentUtility, gettextCatalog) {
        var d = {
            restrict: 'E',
            replace: true,
            require: 'ngModel',
            scope: {
                format: '@',
                extraTooltip: '@?'
            }
        };
        d.template = '<span uib-tooltip="{{tooltip}}">{{datetime}} <i class="fa fa-warning" ng-show="is_specialday"></i></span>';
        d.link = function (scope, element, attr, ngModel) {
            ngModel.$render = function () {
                scope.datetime = swifMomentUtility.formatDatetime(
                    ngModel.$viewValue, scope.format
                );
                scope.timeago = swifMomentUtility.timeago(
                    ngModel.$viewValue
                );
                scope.specialday = swifMomentUtility.get_specialday(ngModel.$viewValue);
                scope.is_specialday = scope.specialday !== undefined;
                scope.tooltip = '';
                if (scope.extraTooltip) {
                    scope.tooltip += scope.extraTooltip + ' ';
                }
                scope.tooltip += scope.timeago;
                if (scope.is_specialday) {
                    scope.tooltip += ' ' + gettextCatalog.getString('Warning');
                    scope.tooltip += ': ' + scope.specialday;
                }
            };
        };
        return d;
    }

})();
